/*
 * @Author: tangke
 * @Date: 2019-03-02 11:42:14
 * @Last Modified by: others
 * @Last Modified time: 2019-03-05 17:03:53
 * 课程详情页classRemark弹窗的仅为trial类型
 */
<template>
  <v-dialog v-model="model"
            max-width="840px">
    <v-card>
      <v-card-title>
        <span class="headline">Class Remarks</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md
                     class="pa-2">
          <v-layout wrap>
            <v-flex xs12>
              <label class="subheading mb-2 d-block">Class Description (For CS):<span class="body-2">If anything special happened in class .please state it</span></label>
              <v-select v-model="e6"
                        :items="states"
                        :menu-props="{ maxHeight: '400' }"
                        no-data-text="Select"
                        label="Select"
                        hint="Select the appropriate option"
                        class="subheading"
                        outline
                        persistent-hint
                        :error-messages="$v.e6.$error ? 'Required!': ''"
                        @input="$v.e6.$touch()"></v-select>
            </v-flex>
            <v-flex xs12
                    class="mt-3">
              <label class="subheading mb-2 d-block">Skill Assessment (Required)</label>
              <cite class="red--text text--darken-2">* Students' special skills scores in class</cite>
              <v-layout wrap>
                <v-flex xs6
                        v-for="(item, index) in skillList"
                        :key="index">
                  <skillScore :title="item.title" :descriptions="item.descriptions" :icon="item.icon" v-model="trailRemarksForm.SkillScore[item.mark]"/>
                  <span class="error--text"
                                    v-if="$v.trailRemarksForm.SkillScore[item.mark].$error">Required!</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12
                    class="mt-4">
              <label class="subheading mb-2 d-block">Performance Assessment (Required) :</label>
              <cite class="red--text text--darken-2">* Students' comprehensive performance scores in class</cite>
              <v-layout wrap>
                <v-flex xs6
                        v-for="(item, index) in PerforList"
                        :key="index">
                  <skillScore :title="item.title" :descriptions="item.descriptions" :icon="item.icon"  v-model="trailRemarksForm.PerforList[item.mark]"/>
                  <span class="error--text"
                                    v-if="$v.trailRemarksForm.PerforList[item.mark].$error">Required!</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12
                    class="mt-4">
              <label class="subheading mb-2 d-block">Level Assessment (Required)</label>
              <cite class="red--text text--darken-2">
                <ol class="ol-type-no pl-0">
                  <li>* CEFR ：Common European Framework of Reference for Languages.</li>
                  <li>* Acadsoc Level System based on CEFR .</li>
                  <li>* Please select a level for the student.</li>
                </ol>
              </cite>
              <levelRate v-model="levelRate"/>
              <span class="error--text" v-if="$v.levelRate.$error">Required!</span>
            </v-flex>
            <v-flex xs12
                    class="mt-4">
              <label class="subheading mb-2 d-block">Tutor Comments (Required)</label>
              <cite class="red--text text--darken-2">* Firstly, the students' English proficiency is graded, then the names of the students and the course names are filled in. Then, please select a suggestion template. If the tutor needs to type more relevant comments, please edit it.</cite>
              <v-card flat
                      class="mt-4">
                <v-btn-toggle v-model="toggle_exclusive">
                  <v-btn v-for="(item,index) in ['Primary','Intermediate','Advanced']"
                         :key="index"
                         color="teal darken-2"
                         class="text-none white--text">{{item}}
                  </v-btn>
                </v-btn-toggle>
                <p class="mt-3">
                  <span>Hi</span>
                  <!-- vuetify中没有找到类似的控件,此处仅仅取学生姓名,因而暂时用Input实现 -->
                  <input class="styleInput"
                         type="text"
                         v-model="studentsName" />
                  <span>(student’s name)! It has truly been a pleasure having you in my class today. In today’s class, we have talked about{{lesson}}. (objectives of the lesson)</span>
                </p>
                <p class="error--text" v-if="$v.studentsName.$error"> student’s name is required!</p>
                <remarkTemplate :selectTem="selectTem"
                                :keys="templateType" />
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="pl-4">
        <v-btn color="green darken-2"
               class="white--text"
               @click="submit()">Submit Class Remarks</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { leaveTrailClassRemark, GetUserUserReportByID } from '@/api/classtable.js'
import skillScore from './skillScore.vue'
import levelRate from './levelRate'
import remarkTemplate from './remarkTemplate'
import vmodel from '@/mixins/v-model'
import { createNamespacedHelpers } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minValue, minLength } from 'vuelidate/lib/validators'
const namespace = 'classDetail'
const { mapGetters } = createNamespacedHelpers(namespace)
export default {
  name: 'classRemarksTrial',
  mixins: [vmodel,validationMixin],
  validations () {
    return {
      trailRemarksForm: {
        SkillScore: {
          vocabulary: { minValue: minValue(1) },
          pronunciation: { minValue: minValue(1) },
          speaking: { minValue: minValue(1) },
          grammar: { minValue: minValue(1) },
          listening: { minValue: minValue(1) },
        },
        PerforList:{
          participation: { minValue: minValue(1) },
          comprehension: { minValue: minValue(1) },
          thinking: { minValue: minValue(1) },
          emotional: { minValue: minValue(1) },
        }
      },
      e6: { required },
      studentsName: { required },
      levelRate: {  minValue: minValue(1) }
    }
  },
  watch: {
    model (model) {
      if (model) {
        // if (!this.currentLesson) {
        //   this.$root.$alert('Missing Current Teaching Material, this shall not happen when you can see this button, please REFRESH page.')
        //   this.model = false
        //   return
        // }
        let usid = this.info.USID
        this.GetRemarkInfo(usid)
      }
    }
  },
  data: () => ({
    e6: '',
    levelRate: 0,
    states: [
      {
        value: 0, text: 'The class went well.And the student had strong intention to learn with Acadsoc'
      },
      {
        value: 1, text: 'The class went well. However, the student did not show much intention to learn with Acadsoc'
      },
      {
        value: 2, text: 'The class did not go well due to poor network connection'
      },
      {
        value: 3, text: 'The class did not go well due to the unpunctuality of the student for various reasons'
      },
      {
        value: 4, text: 'The class did not go well because the material was difficult for the student'
      },
      {
        value: 5, text: 'The class did not go well because the student had difficulties in understanding teacher\'s speaking'
      },
      {
        value: 6, text: 'Other'
      }
    ],
    skillList: [
      {
        icon: 'mood',
        title: 'Vocabulary',
        mark: 'vocabulary',
        descriptions: [
          'The student can\'t spell the vocabulary and hasn\'t understood  the vocabulary of the corresponding level.',
          'The student can basically master the vocabulary of the corresponding level, and can correctly select the vocabulary when expressing themselves, but can\'t use some phrases and fixed collocations.',
          'The student can use vocabulary correctly when expressing themselves, and can use a certain amount of phrases and fixed collocations, and can not grasp the vocabulary collocation in different scenes.',
          'The student can use vocabulary correctly when expressing themselves and has mastered most of the phrases and fixed collocations, as well as mastered vocabulary collocations in some different scenes.',
          'Students can use vocabulary accurately when they express themselves, have mastered most of the phrases and fixed collocations, and can be flexible in using vocabulary collocations in different scenes.'
        ]
      },
      {
        icon: 'mood',
        title: 'Pronunciation',
        mark: 'pronunciation',
        descriptions: [
          'The student doesn\'t know how to pronounce and  the pronunciation cannot be understood.',
          'The student\'s  pronunciation is not very clear, and the student doesn\'t know the rising and falling intonation, stress and weak reading, continuous reading and other pronunciation skills, and the pronunciation is difficult to understand.',
          'The student can pronounce words clearly, understands part of the rising and falling intonation, stress and weak reading, continuous reading and other pronunciation skills, but it is difficult to use it and to be understood.',
          'The student can pronounce very clearly and understands the rising and falling intonation, stress and weak reading, continuous reading and other pronunciation skills. Pronunciation can be understood basically.',
          'Clear articulation, proficiency in English pronunciation and pronunciation, rereading weak reading, continuous reading and other pronunciation skills, pronunciation is very standard, barrier-free in communication .'
        ]
      },
      {
        icon: 'mood',
        title: 'Speaking',
        mark: 'speaking',
        descriptions: [
          'The student speaks intermittently, frequently pauses or repeats themselves, and can only express some basic words and phrases. He/she cannot express ideas in sentences.',
          'The student\'s speed of speech is unstable, paused or repeated. The student can use some phrases and simple sentences to communicate, but  needs to change the way they express themselves and can not clearly express ideas.',
          'The student\'s speed of speech is not so stable, and it is more fluent on familiar topics while the student\'s speech is more repeated, paused and  self-corrected on strange topics . The logic and coherence of expressing meaning is low.',
          'The student\'s speed of speech is stable, and can carry on the detailed oral expression, expands into longer sentences. Occasional pauses or repetition. Good logic and consistency in meaning expression.',
          'Students can speak fluently at normal speed, with little repetition or self-correction. Being able to express ideas in a smooth and free manner, and being able to carry out complex communication, logical and coherent.'
        ]
      },
      {
        icon: 'mood',
        title: 'Grammar',
        mark: 'grammar',
        descriptions: [
          'The student hasn\'t mastered the basic grammar rules, and can\'t build simple sentences to express meaning, and most sentences have grammatical errors.',
          'The student can understand the basic grammar rules but they often make grammatical errors such as person, tense, sentence structure, singular and plural usage.  They do not use complex sentences such as compound sentences.',
          'The student is familiar with basic grammar rules, but sometimes makes grammatical errors such as person, tense, sentence structure, singular and plural usage with some errors in organizing complex sentences.',
          'The student is familiar with the grammar rules of the corresponding level and is more proficient in using various grammars. They can use complex difficult sentences to express meaning clearly, but sometimes make specific grammatical errors.',
          'The student can master the grammar rules of the corresponding level, accurately organize all kinds of grammar, use complex and difficult sentences to express meaning, basically no mistakes.'
        ]
      },
      {
        icon: 'mood',
        title: 'Listening/Understanding',
        mark: 'listening',
        descriptions: [
          'Students can\'t understand the problem and listening material, and the expressed content can\'t be understood.',
          'Students can understand the problem, and occasionally can not understand the listening materials, the expressed content is difficult to understand.',
          'The student can understand the problem and listening materials, and part of  the expressed content can be understood.',
          'The student can understand the problem and listening materials, and most of  the expressed content can be understood.',
          'The student can understand the problem and listening materials very well, and all the expressed content can be understood.'
        ]
      }
    ],
    PerforList: [
      {
        icon: 'stars',
        title: 'Participation',
        mark: 'participation',
        descriptions: [
          'You are calm and diffident, and not quite well in interacting with teacher,but once you practise more in oral English, your English will get better soon.',
          'You could have simple interaction with the teacher in class, English is a two way process in communication, you can communicate efficiently with teacher by practising more.',
          'You can handle and deal with most information in an  English environment, have good interactions with the teacher although there are some mistakes. We believe you will understand native speakers better if you keep studying.',
          'You could communicate very well with teacher in class,and you have great interest in studying English also using English to express yourself. Keep it up, I believe you will make great improvements in your English!'
        ]
      },
      {
        icon: 'stars',
        title: 'Comprehension',
        mark: 'comprehension',
        descriptions: [
          'You haven\'t understood the content you should learn in class, barely reacted in class. You would be better in using English to express yourself with more practice, imitation and with teacher\'s help.',
          'You could master some parts of content in class and respond to simple short sentences, but not very skillful in using them, have made a lot of mistakes. Teacher hopes you could speak English as much as possible, try to practise more so that you will improve your English more.',
          'You could handle most vocabulary,sentence patterns and skills in class,but have made some mistakes once in a while. Hopefully you could try different ways in expressing yourself, and find the best one and the more accurate one.',
          'You have completely mastered all the content in class, you can express your opinions very well and answer questions correctly. Keep it up, I believe you will be an amazing student in English study!'
        ]
      },
      {
        icon: 'stars',
        title: 'Thinking & Creativity',
        mark: 'thinking',
        descriptions: [
          'English is still new to you, you couldn\'t express yourself or ask questions in English.The initial stage of learning English, It\'s an adaptive phase, but it will be easier to use it later!',
          'A complete English course makes you a little stressed, the sentences you could use to express yourself are still limited. Remember to ask the teacher for help actively when you have questions, the teacher will always like to help you in any time.',
          'You could express yourself and ask questions with English in a fluent way, but still need to improve the ability in organizing language. Keep practising in order to avoid mistakes.  It will help you have more fluent communication, with better logic and coherence.',
          'You could fluently express yourself  and correct yourself sometimes, you could make different perspectives, good coherence and logic in expression as well. You are amazing!'
        ]
      },
      {
        icon: 'stars',
        title: 'Emotional Expression',
        mark: 'emotional',
        descriptions: [
          'The first time having 1v1 English class with a foreign teacher might make you a little nervous,anxious and shy. But don\'t be, try to break through it, you will love learning English.',
          'You were not very open in class and didn\'t know how to communicate with the teacher.  You felt shy and nervous , afraid of making mistakes. Don\'t worry.  You will grow and learn from your mistakes, you will speak better English in the future!',
          'You have the courage to express yourself with English, you are active in studying! Remember to ask teacher for help when you have difficulty in expressing yourself or comprehension, try to express yourself in different ways, the teacher will do their best to help you!',
          'You are brave and confident in expressing yourself, and try to express yourself in different ways , keep your passion in learning English, it will become a very helpful asset in your life.'
        ]
      }
    ],
    studentsName: 'student',
    lesson: 'Acadsoc Conversational English for Preliminary 阿卡索商务英语会话初级',
    toggle_exclusive: 0,
    selectTem: [
      {
        select: true,
        descripton: 'You have been trying your best to answer the questions. You hesitated a lot before responding but your fluency will improve quickly when you begin classes. With more practice you will express yourself better. Look forward to seeing you in my class in the future!',
        type: 'primary'
      },
      {
        select: false,
        descripton: 'You have been trying your best to understand and answer my questions and you showed great determination to use English. You might want to work on your weakness. I believe you\'ll improve quickly if you learn with Acadsoc.',
        type: 'primary'
      },
      {
        select: false,
        descripton: 'Although you didn\'t understand some of the questions, you have tried your best to respond, which will help you at the beginning of classes.When you practice more at Acadsoc, I\'m sure you will make great improvement.',
        type: 'primary'
      },
      {
        select: false,
        descripton: 'You were not very familiar with the vocabulary at the beginning, but it is obvious that you have tried your best to use them in sentences. You\'ll be able to express quicker and make complex sentences. I believe that if you study hard with Acadsoc, you will make huge improvement.',
        type: 'primary'
      },
      {
        select: false,
        descripton: 'You can make short and basic sentences. If you knew more words, it would be easier for you to express yourself more and make complex sentences. You answered slowly and sometimes you make long pauses, which shows that you have been really careful in choosing the words and making your sentences. Keep reading and keep talking! You will be able to achieve your goals from learning English more often. Don\'t be afraid to make mistakes! Good luck and I hope to see you in my class again.',
        type: 'primary'
      },
      {
        select: false,
        descripton: 'You have done your best to answer all the questions and asked me to repeat when you were unsure. Your English foundation is fine, however you need to improve your listening skill and increase your vocabulary. I\'m sure you will improve quickly with learning at Acadsoc. I hope to see you soon!',
        type: 'intermediate'
      },
      {
        select: false,
        descripton: 'At the end of the class you were able to understand the vocabulary, and your pronunciation was reasonably clear. You might want to work on your grammar and fluency as you had difficulties in making sentences. You will definitely improve your English if you study hard with Acadsoc. Well done and good luck!',
        type: 'intermediate'
      },
      {
        select: false,
        descripton: 'You were able to answer easy questions really well. I felt that you wanted to tell me more about something that we had discussed. You will find that you will be able to organize your language and express your ideas more clearly after you build your vocabulary with Acadsoc.',
        type: 'intermediate'
      },
      {
        select: false,
        descripton: 'You are an active learner. You could answer questions enthusiastically with own thoughts. I believe that you will be more confident, and you will feel relaxed and comfortable in English conversations after more practice. Enjoy your time at Acadsoc!',
        type: 'intermediate'
      },
      {
        select: false,
        descripton: 'You were able to cooperate well with teacher and had no problem at simple conversation. However, you were struggled when we start advanced topic. During your studies at Acadsoc, you will build your vocabulary and topic range. It will help you a lot. Enjoy your time at Acadsoc!',
        type: 'intermediate'
      },
      {
        select: false,
        descripton: 'You have done well in the class. You are good at understanding and can try best to expand your answers. You need to pay more attention to the grammatical structures such as past tense. You will definitely improve quickly with more practice. Well done and good luck!',
        type: 'advanced'
      },
      {
        select: false,
        descripton: 'You have no problem at discussing simple topics, but were struggled when it comes to more complicated. You will be advised to work on making your language more sophisticated in order to deal with complex topics effectively in your daily life. I\'m sure you will improve quickly at Acadsoc.',
        type: 'advanced'
      },
      {
        select: false,
        descripton: 'I\'m quite impressed on how you converse. You sound natural though there are some mispronounced words. It can be improved by practicing more. You can try to read some English books aloud, watch English movies and English series. You can follow the way they speak to improve your pronunciation.',
        type: 'advanced'
      },
      {
        select: false,
        descripton: 'You have already showed very good English skill. Broadening your vocabulary and expressions and having plenty of practice talking about topics in depth will push your English onto a higher level. Look forward to seeing you in my class in the future!',
        type: 'advanced'
      },
      {
        select: false,
        descripton: 'You are willing to learn, and exhibit a positive outlook and attitude in the class. You are committed to do your best and listen attentively in the class. You follow directions well and take an active role in discussion. Practicing your speaking skill is what you need to focus at the moment. My suggestions for improving your vocabulary are watching easy English shows and movies, reading short English stories and books. I believe that you can keep it up! I hope to see you again. Great Job!',
        type: 'advanced'
      }
    ],
    trailRemarksForm: {
      SkillScore: {
        vocabulary: 0,
        pronunciation: 0,
        speaking: 0,
        grammar: 0,
        listening: 0
      },
      PerforList: {
        participation: 0,
        comprehension: 0,
        thinking: 0,
        emotional: 0
      },
      GradeLevel: 0,
      studentsName: '',
      temple: '',
      Action: '', 
      Uid: 0,
      UCID: '',
      CLID: '',
      SID: '',
      USID: '',
      TUID: '',
      ClassTime: '',
      Sublevel: '',
      Adult: '',
      ReportID: 0,
      templeType:''
    }
  }),
  computed: {
    ...mapGetters(['info', 'currentLesson', 'remarkInfo']),
    templateType: function () {
      let type
      switch (this.toggle_exclusive) {
        case 0: type = 'primary'; break
        case 1: type = 'intermediate'; break
        case 2: type = 'advanced'; break
      }
      return type
    }
  },
  components: {
    skillScore,
    levelRate,
    remarkTemplate
  },
  methods: {
    successTip (msg) {
      return this.$root.$alertTips(msg, 'success')
    },
    errorTip (msg) {
      return this.$root.$alertTips(msg)
    },
    GetRemarkInfo (usid) {
      GetUserUserReportByID(usid).then(res => {
        //this.trailRemarksForm.description = res.CSDesrition
        this.trailRemarksForm.Adult = res.CategoryText
        var skillScore = this.trailRemarksForm.SkillScore
        var perfScore = this.trailRemarksForm.PerforList
        this.e6 = res.Description != '' ? +res.Description : ''
        if (res.ReportModel != null) {
          var skillresult = JSON.parse(res.ReportModel.ReportJosn)
          var perfresult = JSON.parse(res.ReportModel.TrainJson)
          this.trailRemarksForm.ReportID = res.ReportModel.ReportID
          this.levelRate = Number(res.ReportModel.GradeLeve)
          skillScore.vocabulary = skillresult[0].Score
          skillScore.listening = skillresult[1].Score
          skillScore.speaking = skillresult[2].Score
          skillScore.grammar = skillresult[3].Score
          skillScore.pronunciation = skillresult[4].Score
          perfScore.participation = perfresult[0].Score
          perfScore.comprehension = perfresult[1].Score
          perfScore.thinking = perfresult[2].Score
          perfScore.emotional = perfresult[3].Score
        }
      })
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.trailRemarksForm.Action = this.info.AllowLeaveRemark === 1 ? 'Add' : 'Edit'
      this.trailRemarksForm.CLID = this.info.CLID
      this.trailRemarksForm.Classtools = this.info.ClassTools
      this.trailRemarksForm.Uid = this.info.StuUID
      this.trailRemarksForm.UCID = this.info.UCID
      if(this.currentLesson==null){
          this.trailRemarksForm.SID = this.info.SID
          this.trailRemarksForm.USID =this.info.USID
      }else {
         this.trailRemarksForm.SID = this.currentLesson.SID==0 ? this.info.SID : this.currentLesson.SID
         this.trailRemarksForm.USID = this.currentLesson.USID == 0 ? this.info.USID : this.currentLesson.USID
      }
      this.trailRemarksForm.TUID = this.info.TUID
      this.trailRemarksForm.ClassTime = this.info.ClassTime
      this.trailRemarksForm.Sublevel = this.info.SubLevel
      this.trailRemarksForm.GradeLevel = this.levelRate
      this.trailRemarksForm.studentsName = this.studentsName
      this.trailRemarksForm.Description = this.e6
      
      // let currentTem = this.selectTem.filter(p => p.select)[0]
      // this.trailRemarksForm.templeType = currentTem ? currentTem.type : ''
      // this.trailRemarksForm.temple = currentTem ? currentTem.descripton : ''
      
      leaveTrailClassRemark(this.trailRemarksForm).then(r => {
         switch (r) {
            case 1 :
                //this.$toasted.success('Submit success!') 
                this.successTip('Submit success!')
                this.$router.go()
                break;
            case -2:
                this.errorTip('Invalid Data！')
                //this.$toasted.error('Invalid Data！')
                break;
            case -11:
                this.errorTip('Error! Please refresh the page and submit it again')
                //this.$toasted.error('Error! Please refresh the page and submit it again')
                break;
            case -3:
                this.errorTip('Sorry ! The lesson has not begun!!')
                //this.$toasted.error('Sorry ! The lesson has not begun!!')
                break;
            case -4:
                this.errorTip("There's no textbook! Please report to the CS assign the book for the class.")
                //this.$toasted.error("There's no textbook! Please report to the CS assign the book for the class.")
                break;
            case -5:
                this.errorTip('Sorry ! Submission is ONLY allowed AFTER the class.')
                //this.$toasted.error('Sorry ! Submission is ONLY allowed AFTER the class.')
                break;
            case -6:
                this.errorTip('Sorry ! Please fill in correct test score.')
                //this.$toasted.error('Sorry ! Please fill in correct test score.')
                break;
            case -7:
                this.errorTip('Sorry ! Excessive grade.')
                //this.$toasted.error('Sorry ! Excessive grade.')
                break;    
            case -99:
                this.errorTip('Sorry ! Please fill in the complete data.')
                //this.$toasted.error('Sorry ! Please fill in the complete data.')
                break;
            default:
                this.errorTip('Sorry ! System is busy please try again later!!')
                //this.$toasted.error('Sorry ! System is busy please try again later!!')
                break;
            
          }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .ol-type-no {
    list-style: none;
  }
  .styleInput {
    outline: none;
    border: 1px dashed rgba(0, 0, 0, 0.87);
    border-width: 0 0 1px 0;
    width: 138px;
    margin: 0 12px;
    text-align: center;
  }
</style>
